import { TypedUseSelectorHook, useSelector } from 'react-redux'

import type { RootState } from '../store'

// https://redux-toolkit.js.org/tutorials/typescript#define-typed-hooks
const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export default useAppSelector
